import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";
import { ReactNode, useEffect, useState } from "react";
import { StyledToggleButton, StyledToggleButtonGroup } from "./StyledToggleButonGroup";
import { IBuildingBlockControl } from "./BuildingBlockInterfaces";
import { Box } from "@mui/material";
import { UILabel } from "./UILabel";

export interface UIToggleButtonsProps extends IBuildingBlockControl<string> {
    options:
        | string[]
        | {
              value: string;
              text?: string;
              renderUI?: (selected: boolean) => JSX.Element;
              renderIcon?: (selected: boolean) => JSX.Element;
          }[];

    doNotColorBackgroundOnCustomRender?: boolean;
}

export function UIToggleButtons(props: UIToggleButtonsProps) {
    let [val, setVal] = useState<string | undefined>();

    useEffect(() => {
        setVal(props.value);
    }, [props.value]);

    function renderToggleButtons() {
        return (
            <StyledToggleButtonGroup
                value={val ?? ""}
                sx={{
                    border: props.error ? "1px solid " + UIStyleConstants.RED_COLOR : undefined,
                    height: "40px",
                    ...props.sx,
                }}
            >
                {props.options.map((o) => {
                    if (typeof o === "string") {
                        return (
                            <StyledToggleButton
                                onClick={() => {
                                    setVal(o);
                                    props.onChange(o);
                                }}
                                key={o}
                                style={{
                                    padding: "5px",
                                    paddingRight: "10px",
                                    paddingLeft: "12px",
                                    border: "1px solid " + UIStyleConstants.GRAY_LIGHTER_COLOR,
                                }}
                                value={o}
                            >
                                {o}
                            </StyledToggleButton>
                        );
                    } else {
                        let ui: ReactNode;
                        let doNotColorBackground = false;
                        let selected = val === o.value;
                        if (o.renderUI) {
                            ui = o.renderUI(selected);
                            doNotColorBackground = props.doNotColorBackgroundOnCustomRender || false;
                        } else if (o.renderIcon) {
                            ui = o.renderIcon(selected);
                            doNotColorBackground = props.doNotColorBackgroundOnCustomRender || false;
                        } else if (o.text) {
                            ui = o.text;
                        } else {
                            ui = o.value;
                        }
                        return (
                            <StyledToggleButton
                                onClick={() => {
                                    setVal(o.value);
                                    props.onChange(o.value);
                                }}
                                key={o.value}
                                style={{
                                    padding: "5px",
                                    color: !doNotColorBackground && selected ? UIStyleConstants.WHITE_COLOR : undefined,
                                    background:
                                        !doNotColorBackground && selected ? UIStyleConstants.BLUE_COLOR : undefined,
                                    border: "1px solid " + UIStyleConstants.GRAY_LIGHTER_COLOR,
                                }}
                                value={o}
                            >
                                {ui}
                            </StyledToggleButton>
                        );
                    }
                })}
            </StyledToggleButtonGroup>
        );
    }

    if (!props.label && !props.hint && !props.error) {
        return renderToggleButtons();
    } else {
        return (
            <Box
                display={"flex"}
                flexDirection={"column"}
                width={props.fullWidth ? "100%" : undefined}
            >
                {props.label && <UILabel paddingBottom={"5px"}>{props.label}</UILabel>}
                {renderToggleButtons()}
                {(props.error || props.hint) && (
                    <UILabel variant={props.error ? "error_hint" : "hint"}>{props.error ?? props.hint}</UILabel>
                )}
            </Box>
        );
    }
}
